import { render, staticRenderFns } from "./LedgerAppModal.vue?vue&type=template&id=4c6afe48&scoped=true&"
import script from "./LedgerAppModal.vue?vue&type=script&lang=js&"
export * from "./LedgerAppModal.vue?vue&type=script&lang=js&"
import style0 from "./LedgerAppModal.vue?vue&type=style&index=0&id=4c6afe48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6afe48",
  null
  
)

export default component.exports